
export const LayoutSize = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    l: 1150,
    xl: 1200,
    xxl: 1600,
}